import { Text, type TextStyle, View } from 'react-native'
import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Header = styled(View, theme => {
  return {
    base: {
      borderRadius: theme.borderRadiusNone,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
      padding: theme.paddingInsetNone,
      width: '100%',
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {
      disabled: {
        true: {
          backgroundColor: theme.colorContainerFillDisabled,
        },
      },
      isCollapsed: {
        false: {
          paddingBottom: theme.paddingInsetFourpulse,
        },
      },
    },
  }
})

export const Title = styled(Text, theme => {
  const baseFontWeight = String(theme.fontWeightBold) as TextStyle['fontWeight']
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeFourpulse,
      fontWeight: baseFontWeight,
      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      flex: 1,
      fontFamily: 'RDModern-Bold',
    },
    variants: {
      disabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
